/**
 * @author       Matthieu Devlin (matt@zumper.com)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  getParameterizedRouteName.ts
 */

import { patterns, routesConstants } from '@zcode/zumper-routes'

const { FILTERS_PATH_RE } = routesConstants

const CITY_STATE_RE = new RegExp(
  `^\\/(${patterns.propertyTypePath.source})/${patterns.cityState.source}/?$`
)
const CITY_STATE_FILTERS_RE = new RegExp(
  `^\\/(${patterns.propertyTypePath.source})/${patterns.cityState.source}${FILTERS_PATH_RE.source}`
)
const CITY_STATE_HOOD_RE = new RegExp(
  `^\\/(${patterns.propertyTypePath.source})/${patterns.cityState.source}/${patterns.hoodName.source}/?$`
)
const CITY_STATE_HOOD_FILTERS_RE = new RegExp(
  `^\\/(${patterns.propertyTypePath.source})/${patterns.cityState.source}/${patterns.hoodName.source}${FILTERS_PATH_RE.source}`
)

export const parameterizeXfrPath = (pathname: string): string | undefined => {
  if (pathname.match(patterns.propertyTypePath)) {
    const cityStateMatch = pathname.match(CITY_STATE_RE)
    if (cityStateMatch) {
      return `/${cityStateMatch[1]}/:cityState`
    }

    const cityStateFiltersMatch = pathname.match(CITY_STATE_FILTERS_RE)
    if (cityStateFiltersMatch) {
      return `/${cityStateFiltersMatch[1]}/:cityState/:filtersPath`
    }

    const cityStateHoodMatch = pathname.match(CITY_STATE_HOOD_RE)
    if (cityStateHoodMatch) {
      return `/${cityStateHoodMatch[1]}/:cityState/:hoodName`
    }

    const cityStateHoodFiltersMatch = pathname.match(CITY_STATE_HOOD_FILTERS_RE)
    if (cityStateHoodFiltersMatch) {
      return `/${cityStateHoodFiltersMatch[1]}/:cityState/:hoodName/:filtersPath`
    }
  }
  return undefined
}
